import axios from 'axios';

window.initIntrospect = function () {
  function updateResult(elementId, status, statusText) {
    const result = document.getElementById(elementId);
    result.querySelector('span').innerText = `${status} ${statusText}`;
    result.classList.toggle('status2xx', status >= 200 && status < 300);
    result.classList.toggle('status4xx', status >= 400 && status < 500);
    result.classList.toggle('status5xx', status >= 500);
    result.classList.remove('hidden');
  }

  function showUserData(elementId, b64Data) {
    const element = document.getElementById(elementId);
    if (b64Data) {
      element.innerText = JSON.stringify(JSON.parse(atob(b64Data, 'base64')), null, 2);
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  }

  document.getElementById('auth-check').addEventListener('click', async event => {
    event.preventDefault();
    try {
      const response = await axios.get('/v1/auth', { withCredentials: true });
      updateResult('cookie-result', response.status, response.statusText);
      showUserData('cookie-user-data', response.headers['x-leafly-user-b64-json']);
    } catch (e) {
      updateResult('cookie-result', e.response.status, e.response.statusText);
      showUserData('cookie-user-data', '');
    }
  });

  document.getElementById('token').addEventListener('submit', async event => {
    event.preventDefault();
    try {
      // Using fetch instead of axios because fetch can omit cookies and axios can't
      const response = await fetch('/v1/auth', { credentials: 'omit', headers: { Cookie: '', Authorization: `Bearer ${event.target.token.value}` }});
      updateResult('token-result', response.status, response.statusText);
      showUserData('token-user-data', response.headers.get('x-leafly-user-b64-json'));
    } catch (e) {
      updateResult('token-result', e.response.status, e.response.statusText);
      showUserData('token-user-data', '');
    }
  });
}
